<template>
    <div class="accept-terms">
        <div class="accept-terms__content">
            <router-link to="/">
                <img
                    src="@/assets/images/logos/accounts-logo.svg"
                    class="accept-terms__logo img-fluid"
                    alt="Tendencys"
                />
            </router-link>
            <accept-terms-form />
        </div>
    </div>
</template>

<script>
import AcceptTermsForm from '@/components/forms/AcceptTerms.vue';

export default {
    name: 'accept-terms',
    components: {
        AcceptTermsForm,
    },
};
</script>

<style lang="scss">
.accept-terms {
    text-align: center;
    position: relative;

    &__content {
        max-width: 650px;
        margin-left: auto;
        margin-right: auto;
    }

    &__logo {
        margin-bottom: 35px;
    }

    &__title {
        font-size: 35px;
        font-weight: 600;
        margin-bottom: 30px;
    }

    &__text {
        color: #787F84;
        font-size: 16px;
        margin-bottom: 30px;
        font-weight: 400;
    }
}
</style>
